(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else {
		var a = factory();
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 23);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return normalizeComponent; });
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent (
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier, /* server only */
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () { injectStyles.call(this, this.$root.$options.shadowRoot) }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}


/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("babel-runtime/helpers/defineProperty");

/***/ }),

/***/ 122:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 149:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 16:
/***/ (function(module, exports) {

module.exports = require("babel-runtime/helpers/toConsumableArray");

/***/ }),

/***/ 23:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./components/style/index.less
var style = __webpack_require__(122);

// EXTERNAL MODULE: ./components/checkbox/style/index.less
var checkbox_style = __webpack_require__(149);

// CONCATENATED MODULE: ./components/checkbox/style/index.js


// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./components/checkbox/checkbox.vue?vue&type=template&id=0689a564&
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "label",
    { class: _vm.disabledClasses, on: { click: _vm.handleClick } },
    [
      _c("span", { class: _vm.classes }, [
        _c("input", {
          class: _vm.prefixCls + "-input",
          attrs: { type: "checkbox" }
        }),
        _c("span", { class: _vm.prefixCls + "-inner" })
      ]),
      _vm.$slots.default !== undefined
        ? _c("span", [_vm._t("default")], 2)
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true


// CONCATENATED MODULE: ./components/checkbox/checkbox.vue?vue&type=template&id=0689a564&

// EXTERNAL MODULE: external "babel-runtime/helpers/defineProperty"
var defineProperty_ = __webpack_require__(1);
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty_);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./components/checkbox/checkbox.vue?vue&type=script&lang=js&

//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var checkboxvue_type_script_lang_js_ = ({
  name: 'MdsCheckbox',
  props: {
    checked: {
      type: Boolean,
      default: false
    },
    value: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    indeterminate: {
      type: Boolean,
      default: false
    },
    prefixCls: {
      type: String,
      default: 'mds-checkbox'
    },
    isTransfer: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      _Group: null,
      checkedValue: this.checked
    };
  },

  computed: {
    classes: function classes() {
      var _ref;

      var prefixCls = this.prefixCls;
      return ['' + prefixCls, (_ref = {}, defineProperty_default()(_ref, prefixCls + '-checked', this.checkedValue), defineProperty_default()(_ref, prefixCls + '-disabled', this.disabled), defineProperty_default()(_ref, prefixCls + '-indeterminate', this.indeterminate), _ref)];
    },
    disabledClasses: function disabledClasses() {
      var prefixCls = this.prefixCls;
      var isTransfer = this.isTransfer;

      if (isTransfer) {
        var _ref2;

        return ['' + prefixCls, (_ref2 = {}, defineProperty_default()(_ref2, 'mds-transfer-disabled', this.disabled), defineProperty_default()(_ref2, 'mds-transfer-checked', this.checked), defineProperty_default()(_ref2, prefixCls + '-wrapper', true), _ref2)];
      }
      return ['' + prefixCls, defineProperty_default()({}, prefixCls + '-wrapper', true)];
    },
    isGroup: function isGroup() {
      this.parent = this.$parent;
      while (this.parent) {
        if (this.parent.$options.name !== 'MdsCheckboxGroup') {
          this.parent = this.parent.$parent;
        } else {
          this._Group = this.parent;
          return true;
        }
      }
      return false;
    }
  },
  mounted: function mounted() {
    // 初始化传递值
    this.isGroup && (this.checkedValue = this._Group.value.includes(this.value));
    this.isGroup && this._Group.addItems(this);
  },
  destroyed: function destroyed() {
    this.isGroup && this._Group.removeItems(this);
  },

  watch: {
    checked: function checked(val) {
      this.checkedValue = val;
    }
  },
  methods: {
    handleClick: function handleClick(e) {
      if (!this.disabled && e && e.target.tagName.toUpperCase() === 'INPUT') {
        this.checkedValue = !this.checkedValue;
        if (this._Group && !this._Group.isOptions) {
          this._Group.slotCheck(this.value, this.checkedValue);
        } else {
          this.$emit('change', this.checkedValue, this.value);
        }
      }
    }
  }
});
// CONCATENATED MODULE: ./components/checkbox/checkbox.vue?vue&type=script&lang=js&
 /* harmony default export */ var checkbox_checkboxvue_type_script_lang_js_ = (checkboxvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(0);

// CONCATENATED MODULE: ./components/checkbox/checkbox.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  checkbox_checkboxvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "components/checkbox/checkbox.vue"
/* harmony default export */ var checkbox_checkbox = (component.exports);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./components/checkbox/checkbox-group.vue?vue&type=template&id=4cdfddd6&
var checkbox_groupvue_type_template_id_4cdfddd6_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.prefixCls + " " + _vm.direction },
    [
      _vm._l(_vm.items, function(item, index) {
        return _c(
          "checkbox",
          {
            key: index,
            class: _vm.prefixCls + "-item",
            style: { dispaly: _vm.block },
            attrs: {
              checked: item.checked,
              disabled: _vm.disable(item),
              isTransfer: _vm.isTransfer,
              value: item.value
            },
            on: { change: _vm.change }
          },
          [_vm._v(_vm._s(item.label) + "\n  ")]
        )
      }),
      !_vm.isOptions ? _vm._t("default") : _vm._e()
    ],
    2
  )
}
var checkbox_groupvue_type_template_id_4cdfddd6_staticRenderFns = []
checkbox_groupvue_type_template_id_4cdfddd6_render._withStripped = true


// CONCATENATED MODULE: ./components/checkbox/checkbox-group.vue?vue&type=template&id=4cdfddd6&

// EXTERNAL MODULE: external "babel-runtime/helpers/toConsumableArray"
var toConsumableArray_ = __webpack_require__(16);
var toConsumableArray_default = /*#__PURE__*/__webpack_require__.n(toConsumableArray_);

// EXTERNAL MODULE: external "babel-runtime/core-js/object/assign"
var assign_ = __webpack_require__(8);
var assign_default = /*#__PURE__*/__webpack_require__.n(assign_);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./components/checkbox/checkbox-group.vue?vue&type=script&lang=js&


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var checkbox_groupvue_type_script_lang_js_ = ({
  name: 'MdsCheckboxGroup',
  components: { Checkbox: checkbox_checkbox },
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    prefixCls: {
      type: String,
      default: 'mds-checkbox-group'
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    direction: {
      type: String,
      default: ''
    },
    isTransfer: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      slotItems: []
    };
  },

  computed: {
    items: function items() {
      var _this = this;

      return this.options.map(function (item) {
        var _item = item.constructor === String ? { label: item, value: item } : item;
        return assign_default()({}, _item, { checked: _this.value.includes(_item.value) });
      });
    },
    isOptions: function isOptions() {
      return this.options.length !== 0;
    }
  },
  methods: {
    change: function change(checked, val) {
      this.items.map(function (item) {
        if (item.value === val) {
          item.checked = checked;
        }
      });
      var value = this.items.filter(function (item) {
        return item.checked === true;
      }).map(function (item) {
        return item.value;
      });
      this.$emit('input', value);
      this.$emit('change', value, this.items);
    },
    slotCheck: function slotCheck(val, flag) {
      var value = [].concat(toConsumableArray_default()(this.value));
      if (flag) {
        value.push(val);
      } else {
        value = value.filter(function (item) {
          return item !== val;
        });
      }
      this.$emit('input', value);
      this.$emit('change', value);
    },
    disable: function disable(item) {
      return this.disabled || item.disabled === true;
    },
    addItems: function addItems(vm) {
      if (!this.isOptions) {
        this.slotItems.push(vm);
      }
    },
    removeItems: function removeItems(vm) {
      if (!this.isOptions) {
        this.slotItems = this.slotItems.filter(function (item) {
          return item !== vm;
        });
      }
    }
  },
  watch: {
    value: function value() {
      var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      if (!this.isOptions) {
        this.slotItems.map(function (item) {
          if (val.includes(item.value)) {
            item.checkedValue = true;
          } else {
            item.checkedValue = false;
          }
        });
      }
    }
  }
});
// CONCATENATED MODULE: ./components/checkbox/checkbox-group.vue?vue&type=script&lang=js&
 /* harmony default export */ var checkbox_checkbox_groupvue_type_script_lang_js_ = (checkbox_groupvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./components/checkbox/checkbox-group.vue





/* normalize component */

var checkbox_group_component = Object(componentNormalizer["a" /* default */])(
  checkbox_checkbox_groupvue_type_script_lang_js_,
  checkbox_groupvue_type_template_id_4cdfddd6_render,
  checkbox_groupvue_type_template_id_4cdfddd6_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var checkbox_group_api; }
checkbox_group_component.options.__file = "components/checkbox/checkbox-group.vue"
/* harmony default export */ var checkbox_group = (checkbox_group_component.exports);
// CONCATENATED MODULE: ./components/checkbox/index.js
/* concated harmony reexport MdsCheckbox */__webpack_require__.d(__webpack_exports__, "MdsCheckbox", function() { return checkbox_checkbox; });
/* concated harmony reexport MdsCheckboxGroup */__webpack_require__.d(__webpack_exports__, "MdsCheckboxGroup", function() { return checkbox_group; });




checkbox_checkbox.Group = checkbox_group;


/* istanbul ignore next */
checkbox_checkbox.install = function (Vue) {
  Vue.component(checkbox_checkbox.name, checkbox_checkbox);
  Vue.component(checkbox_group.name, checkbox_group);
};
/* harmony default export */ var components_checkbox = __webpack_exports__["default"] = (checkbox_checkbox);

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

module.exports = require("babel-runtime/core-js/object/assign");

/***/ })

/******/ });
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@bic-fe/mds-ui/dist/checkbox.js
// module id = SlRo
// module chunks = 0